import { Map as ImmutableMap } from 'immutable';
import { VisualTypes } from '../schema/visual-records';
//@ts-expect-error untyped dependency
import { updateVisualType } from '../updaters/report';
import { asTable } from './report-utils';
const discardConditionalFormatting = report => {
  var _report$visual;
  if (((_report$visual = report.visual) === null || _report$visual === void 0 ? void 0 : _report$visual.type) !== VisualTypes.TABLE) {
    return report;
  }
  const encodings = report.getIn(['visual', 'encodings', 'columns']);
  const newEncodings = encodings.map(encoding => {
    return encoding.setIn(['options', 'format', 'conditionalFormatting'], ImmutableMap({
      useConditionalFormatting: false
    }));
  });
  return report.setIn(['visual', 'encodings', 'columns'], newEncodings);
};
export const convertReportToSummaryTable = ({
  reportDefinition,
  userInfo,
  tableAndPropertyMeta,
  name,
  description
}) => {
  const currentVisualType = reportDefinition.getIn(['visual', 'type']);
  const getTableReportDefWithMods = () => {
    if (currentVisualType === VisualTypes.GAUGE) {
      return asTable(reportDefinition).setIn(['visual', 'options', 'showTotals'], false);
    }
    if (currentVisualType === VisualTypes.HORIZONTAL_BAR) {
      // Horizontal bar charts need to be converted to vertical bar charts first in order
      // to ensure that dimensions are rendered in the first column of the table, so that
      // totals for measures are rendered properly in the table footer.
      const reportAsVerticalBar = updateVisualType(reportDefinition, {
        type: VisualTypes.VERTICAL_BAR,
        deps: {
          userInfo,
          meta: tableAndPropertyMeta
        }
      });
      return updateVisualType(reportAsVerticalBar, {
        type: VisualTypes.TABLE,
        deps: {
          userInfo,
          meta: tableAndPropertyMeta
        }
      });
    }
    return updateVisualType(reportDefinition, {
      type: VisualTypes.TABLE,
      deps: {
        userInfo,
        meta: tableAndPropertyMeta
      }
    });
  };
  return ImmutableMap({
    name,
    description,
    reportDefinition: discardConditionalFormatting(getTableReportDefWithMods())
  });
};